export const defaultDigitalData = {
  page: {
    pageName: '',
    siteSection: '',
    hierarchy: '',
    userLanguage: '',
    client: '',
    country: '',
    site: '',
    pageNameNoVehicle: '',
    tool: '',
    toolDescriptor: '',
    radUIVersion: '',
  },
  video: {
    videoTrack: '',
    videoName: '',
    segmentTime: '',
    videoNamePercentageWatched: '',
    videoNamePageName: '',
  },
  user: {
    fdafCode: '',
    fordRegion: '',
    leadOptIn: '',
    leadType: '',
    loginStatus: '',
    optInStatus: '',
    paCode: '',
    registeredStatus: '',
  },
  onclick: {
    onclick: '',
    onclickLinkName: '',
    referredTo: '',
  },
  vehicle: {
    modelYear: '',
    nameplate: '',
  },
  event: {
    action: '',
  },
};

export type DigitalDataType = typeof defaultDigitalData;

export type EventDataProperty = {
  propertyDescriptor: string;
  value: string;
};

export type AnalyticsEvent = {
  name: string;
  directCallName: string;
  digitalDataProperties: EventDataProperty[];
};

export type AnalyticsPageDataType = {
  [pageName: string]: {
    events: AnalyticsEvent[];
  };
};

export type CombinedDigitalDataType = {
  digitalData: DigitalDataType;
  directCallName: string;
};
